export default {"quantityManagerWrapper":"_9m7rg","number":"bel87","disabled":"km6bt","less":"Syr65","more":"tNY-Z","icon":"_3bBIl"};